// export const formatCurrency = (value, {removeSymbol} = {}) => {
export const formatCurrency = (value) => {
  return (+value).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD'
  })
  // let with_commas =  (+value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
  // with_commas = isNaN(with_commas) ? '0.00' : with_commas;
  // return removeSymbol ? with_commas : '$' + with_commas ;
}

// function currencyFormat(num) {
//   return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
// }
export const addressLink = (item) => {
  return `http://maps.google.com/?saddr=current+location&daddr=${item.address}${item.address2 ? `+${item.address2}` : ''},+${item.city}+${item.state},+${item.zip}`.replace(
    /\s/g,
    '%20'
  )
}

export const ucFirst = (string) => {
  if (!string || typeof string !== 'string') {
    return string
  }
  return string[0].toUpperCase() + string.slice(1)
}

export const showEditLinks = () => {
  let element = document.body // document.getElementById("legendary");
  if (element.classList.contains('show_edit_links')) {
    element.classList.remove('show_edit_links')
  } else {
    element.classList.add('show_edit_links')
  }
}

export const followLink = (e, navigate, url) => {
  e.ctrlKey || e.metaKey ? window.open(url) : navigate(url)
}
